export default "__VITE_ASSET__7e55be7b__"